import { useState, useEffect } from 'react';
import { decodeBase64Value, handleUnexpectedException } from 'src/helpers/functions';
import { networkProvider } from 'src/utils/networkProvider';
import { smartContract } from 'src/utils/smartContract';

function useAvailableClaim(userAddress) {
    const [availableClaim, setAvailableClaim] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchAvailableClaim = async () => {
            try {
                const interaction = smartContract.methods.availableClaim([userAddress]);
                const query = interaction.check().buildQuery();
                const queryResponse = await networkProvider.queryContract(query);
                const claimAmount = queryResponse.returnData[0];

                setAvailableClaim(decodeBase64Value(claimAmount) || 0);
            } catch (err) {
                handleUnexpectedException(err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        if (userAddress) {
            fetchAvailableClaim();
        }
    }, [userAddress]);

    return { availableClaim, loading, error };
}

export default useAvailableClaim;
